import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { OrderService } from '../../services/order.service';
import { NotificationService } from '../../services/notification.service';
import { ReferenceNumber, SearchReferenceType } from '../../models/models';

@Component({
    selector: 'reference-number-form',
    templateUrl: './reference-number-form.component.html',
    standalone: false
})
export class ReferenceNumberForm implements OnChanges, OnInit {
    @Input() refNum: ReferenceNumber = {} as ReferenceNumber;
    @Input() recordType: string = "";
    @Output() onRefresh = new EventEmitter<any>();

    public referenceTypeList: SearchReferenceType[] = [];
    public isLoading: boolean = false;

    constructor(private orderService: OrderService, private notificationService: NotificationService) {
    }

    ngOnInit() {
        this.getReferenceTypes();
        console.log("ngOnInit", this.refNum);
    }

    ngOnChanges() {
        console.log("ngOnChanges", this.refNum);
    }

    private getReferenceTypes() {
        this.orderService.getSearchReferenceTypesByRecordType(this.recordType).subscribe(result => {
            this.referenceTypeList = result.resultCollection;
        });
    }

    public save() {
        this.isLoading = true;
        console.log("save", this.refNum);
        var refType = this.referenceTypeList.find(t => t.referenceTypeID == this.refNum.referenceTypeID);
        if (refType != null) {
            this.refNum.referenceType = refType.referenceName;
        }
        this.orderService.saveReferenceNumber(this.refNum).subscribe(result => {
            this.isLoading = false;
            if (result.referenceNumberId > 0) {
                //this.getCustomers();
                this.onRefresh.emit();
            } else {
                this.notificationService.showError("Failed to save record.", "ERROR: Failed to Save");
            }
        });

        this.refNum = {} as ReferenceNumber;
    }

    public cancel() {
        this.onRefresh.emit();
    }
}